import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { profileKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useAssignProjectsToUser(userId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (projectIds: number[]) =>
      apiClient.url(`/users/${userId}/projects`).put({ projectIds }).res(),
    onError: () => {
      toast.add({
        description: "Failed to update accounts",
        timeout: 3000,
        type: "error",
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: profileKeys.userById(userId) });
      toast.add({
        description: "Projects updated successfully",
        timeout: 3000,
        type: "success",
      });
    },
  });
}
